import {remCalc} from '_themeUtils'

const wallMixedVideo = {
    WallMixedVideo: {
        baseStyle: ({
            text_align,
            h_align,
            v_align,
            videoPadding,
            button_background,
            content_color,
            button_color,
            layout_text_below_image,
            ratioDesktop,
            ratioMobile,
            mobileSideBySide,
        }) => ({
            boxWrapper: {
                paddingRight: videoPadding.right + 'px',
                paddingBottom: videoPadding.bottom + 'px',
                paddingLeft: videoPadding.left + 'px',
                paddingTop: videoPadding.top + 'px',
                justifyContent: 'center',
                textAlign: text_align || 'center',
                alignItems: h_align === 'left' ? 'flex-start' : h_align === 'right' ? 'flex-end' : 'center',
                gap: layout_text_below_image ? remCalc(8) : remCalc(64),
                color: content_color,
                position: layout_text_below_image ? 'unset' : 'relative',
            },
            videoWrapper: {
                w: 'full',
                position: 'relative',
                overflow: 'hidden',
                sx: {
                    '& video': {
                        display: 'block',
                        transform: 'scale(1.01)',
                        transformOrigin: 'center',
                    },
                },
            },
            video: {
                padding: '0',
                aspectRatio: {
                    base: ratioMobile || ratioDesktop || 750 / 1071,
                    md: ratioDesktop || 256 / 365,
                    lg: ratioDesktop || 854 / 1219,
                },
            },
            titleContainer: {
                position: 'absolute',
                right: {base: videoPadding.right + (mobileSideBySide ? 24 : 48) + 'px', md: videoPadding.right + 48 + 'px'},
                bottom: {base: videoPadding.bottom + (mobileSideBySide ? 24 : 48) + 'px', md: videoPadding.bottom + 48 + 'px'},
                left: {base: videoPadding.left + (mobileSideBySide ? 24 : 48) + 'px', md: videoPadding.left + 48 + 'px'},
                top: {base: videoPadding.top + (mobileSideBySide ? 24 : 48) + 'px', md: videoPadding.top + 48 + 'px'},
                justifyContent: v_align === 'top' ? 'flex-start' : v_align === 'bottom' ? 'flex-end' : 'center',
                textAlign: text_align || 'center',
                alignItems: h_align === 'left' ? 'flex-start' : h_align === 'right' ? 'flex-end' : 'center',
                gap: 'spacing.4',
                color: content_color,
            },
            titleContainerBelow: {
                w: 'full',
                justifyContent: 'center',
                textAlign: text_align || 'center',
                alignItems: h_align === 'left' ? 'flex-start' : h_align === 'right' ? 'flex-end' : 'center',
                color: content_color,
                gap: 'spacing.4',
            },
            title: {
                color: content_color ? content_color : 'color.text.black',
                textStyle: {base: mobileSideBySide ? 'paragraphLg' : 'displayXs', md: 'displayXs'},
                fontWeight: 'normal',
            },
            titleBelow: {
                color: content_color ? content_color : 'color.text.black',
                textStyle: {base: mobileSideBySide ? 'paragraphLg' : 'paragraphMd', md: 'paragraphMd'},
                fontWeight: 'normal',
            },
            text: {
                width: '75%',
                color: content_color ? content_color : 'color.text.black',
                fontWeight: 'normal',
                textStyle: {base: mobileSideBySide ? 'paragraphSm' : 'paragraphLg', md: 'paragraphLg'},
                sx: {wordWrap: 'normal'},
            },
            textBelow: {
                width: '90%',
                color: content_color ? content_color : 'color.text.black',
                fontWeight: 'light',
                textStyle: {base: mobileSideBySide ? 'paragraphSm' : 'paragraphLg', md: 'paragraphLg'},
                sx: {wordWrap: 'normal'},
            },
            textCta: {
                color: button_color,
            },
            buttonColor: {
                color: button_color,
                background: button_background,
                borderColor: button_background,
            },
            ctaLinkStyle: {
                color: button_color,
                borderBottomColor: button_color,
                p: {base: `${remCalc(7)}, ${remCalc(7)}, ${remCalc(2)}`, md: remCalc(7)},
                display: {base: 'inline', md: 'inline-flex'},
                whiteSpace: 'normal',
                fontSize: {base: mobileSideBySide ? remCalc(12) : layout_text_below_image ? remCalc(14) : 'md', md: 'md'},
            },
        }),
    },
}

export default wallMixedVideo
